import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { provideListView } from '@y42/core/list-view';
import { DatasourceListViewData } from '@y42/datasource';
import { OrchestrationDatasourceSelectorService } from './orchestration-datasource-selector.service';

@UntilDestroy()
@Component({
  selector: 'y42-orchestration-datasource-selector',
  templateUrl: './orchestration-datasource-selector.component.html',
  styleUrls: ['./orchestration-datasource-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideListView(OrchestrationDatasourceSelectorService)],
})
export class OrchestrationDatasourceSelectorComponent {
  @Input() selectedDatasourcePaths: string[] = [];

  @Output() datasourcesSelectionChanged = new EventEmitter<string[]>();

  selectDatasourceTables(datasources: DatasourceListViewData[]) {
    const datasourceTablePaths = datasources.map((t) => t.child_$path);
    this.datasourcesSelectionChanged.emit(datasourceTablePaths);
  }
}
